export default "__VITE_ASSET__1bf0108c__"